import React from "react";
import { formatLongDate } from "utilities";
import { NextIsAgainReadOnly, NextIsCancelled, NextIsFree, NextIsPaid, NotImplementedSubscription, TermsRow } from "../Components/CommonPanelContent";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const DetailsTable = (props: Props) => {
  const showNextInvoiceRow = () => (props.nextSubscriptionType.value === "readOnly");

  return (<table className="s1_table clean rowspace-small margin-bottom-large">
    <tbody>
      <tr>
        <td>{RESX.Subscription.resxSubscription}</td>
        <td>{RESX.Subscription.ReadOnly}</td>
      </tr>
      {showNextInvoiceRow() && <tr>
        <td>{RESX.Subscription.Renewal}</td>
        <td>{formatLongDate(props.activeSubscription.end)}</td>
      </tr>}
      <TermsRow />
    </tbody>
  </table>
  );
};

const ReadOnlySubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <>
        <DetailsTable {...props} />
        <NextIsFree {...props} />
      </>;
    case "paid":
      return <>
        <DetailsTable {...props} />
        <NextIsPaid {...props} />
      </>;
    case "readOnly":
      return <>
        <NextIsAgainReadOnly {...props} />
      </>;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <>
        <DetailsTable {...props} />
        <NextIsCancelled {...props} />
      </>;
    default:
      return <>
        <DetailsTable {...props} />
        <NotImplementedSubscription />
      </>;
  }
};

export default ReadOnlySubscription;
